<template>
  <div ref="chartRef" class="sales-return-chart"></div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, watch, nextTick } from 'vue'
import * as echarts from 'echarts'

export default {
  name: 'SalesReturnBarChart',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    xKey: {
      type: String,
      default: 'date'
    },
    xFormatter: {
      type: Function,
      default: (v) => v
    }
  },
  setup(props) {
    const chartRef = ref(null)
    let chart = null

    const buildOption = () => {
      const list = (props.data || []).slice().sort((a, b) => {
        return String(a[props.xKey]).localeCompare(String(b[props.xKey]))
      })
      const categories = list.map(r => props.xFormatter(r[props.xKey]))
      const sales = list.map(r => Number(r.salesStock || 0))
      const returns = list.map(r => Number(r.returnStock || 0))
      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' }
        },
        legend: {
          data: ['销售出库', '退货入库'],
          top: 4
        },
        grid: {
          left: 40,
          right: 16,
          top: 36,
          bottom: 32
        },
        xAxis: {
          type: 'category',
          data: categories,
          axisLabel: {
            interval: 'auto',
            rotate: categories.length > 12 ? 35 : 0
          }
        },
        yAxis: {
          type: 'value',
          minInterval: 1
        },
        series: [
          {
            name: '销售出库',
            type: 'bar',
            data: sales,
            itemStyle: { color: '#ff4d4f' },
            barMaxWidth: 28
          },
          {
            name: '退货入库',
            type: 'bar',
            data: returns,
            itemStyle: { color: '#fa8c16' },
            barMaxWidth: 28
          }
        ]
      }
    }

    const render = () => {
      if (!chart) return
      chart.setOption(buildOption(), { notMerge: true })
    }

    const handleResize = () => {
      if (chart) chart.resize()
    }

    onMounted(async () => {
      await nextTick()
      chart = echarts.init(chartRef.value)
      render()
      window.addEventListener('resize', handleResize)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', handleResize)
      if (chart) {
        chart.dispose()
        chart = null
      }
    })

    watch(() => props.data, () => render(), { deep: true })

    return { chartRef }
  }
}
</script>

<style scoped>
.sales-return-chart {
  width: 100%;
  height: 260px;
}
</style>
